export default {
  EXTEND_ADMIN_EMAIL: 'extendadminsprod@evgo.com',
};
